module.exports = __webpack_public_path__ + "images/limit-notifications-1257c18e.svg";